module.exports = __webpack_public_path__ + "static/media/invite-animation.6c4e759b.svg";